import React from 'react';
import CommonModal from '../../commons/Modal/CommonModal';

const AllSupportModal = ({ props }) => {
  const {
    state: supportState,
    handleCloseClearUser,
    handleCloseAddUser,
  } = props;

  return (
    <>
<CommonModal
  open={supportState.openAddUser}
  handleClose={handleCloseAddUser}
  onCancel={handleCloseAddUser} // ✅ this ensures Cancel button closes modal
  title="Confirm Ticket Submission"
  message={
    <>
      You're about to raise a ticket. It will be sent to the Software Management team for review.
      <br />
      Are you sure you want to proceed.
    </>
  }
  confirmText="Yes, Raise Ticket"
  cancelText="Cancel"
  onConfirm={() => {
    console.log('Register');
    handleCloseAddUser(); // Optional: close after confirm
  }}
/>



     
    </>
  );
};

export default AllSupportModal;
